import {PickupAppointmentType} from "../graphql/types/PickupTaskWithAppointmentsType";
import { usePickupStore } from "../store/pickupStore";

class PickupNavigationService {

    /**
     * 获取下一个揽收点的信息
     * @param currentStopNumber 当前stopNumber
     * @returns 下一个揽收点信息或null（如果是最后一个）
     */
    async getNextPickupItem(currentStopNumber: number |  undefined): Promise<PickupAppointmentType | null> {
        if (!currentStopNumber) return null;
        const allItems = await this.getAllActivePickupItems();
        const currentIndex = allItems.findIndex(
            item => item.sequence === currentStopNumber
        );

        if (currentIndex !== -1 && currentIndex < allItems.length - 1) {
            return allItems[currentIndex + 1];
        }

        return null; // 最后一条数据
    }

    /**
     * 获取第一个揽收点的信息（用于部分交接包裹场景）
     * @returns 第一个揽收点信息或null（如果没有有效数据）
     */
    async getFirstPickupItem(): Promise<PickupAppointmentType | null> {
        const allItems = await this.getAllActivePickupItems();
        return allItems.length > 0 ? allItems[0] : null;
    }

    /**
     * 检查是否是最后一条数据
     */
    async isLastPickupItem(currentStopNumber: number): Promise<boolean> {
        const nextItem = await this.getNextPickupItem(currentStopNumber);
        return nextItem === null;
    }

    /**
     * 获取所有有效的揽收数据（排除已取消的）
     * 确保获取最新数据而不是缓存数据
     */
    private async getAllActivePickupItems(): Promise<PickupAppointmentType[]> {
        const pickupTaskAppointmentList = await usePickupStore.getState().refreshPickupTaskAppointmentList();
        return pickupTaskAppointmentList.filter((item: PickupAppointmentType) =>
            item.status !== 'CANCELLED' && item.status !== 'TRANSFER_OUT' && !item.isFinished) // 过滤掉已取消的和已完成的
            .sort((a: PickupAppointmentType, b: PickupAppointmentType) => a.sequence - b.sequence) || [];
    }
}

export const pickupNavigationService = new PickupNavigationService();